import React, { ReactNode, ReactElement } from "react";
import "./style.scss";
export interface IFilterInputFormProps {
   children?: ReactNode[] | ReactNode;
}

export function FilterInputForm(props: IFilterInputFormProps): ReactElement {
   return <div className={"filter-input-form"}>{props.children}</div>;
}
